import { Box, Text } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

interface Props {
  contractTypeName?: string | null
}

const ContractType = ({ contractTypeName }: Props) => {
  return (
    <Box gridColSpan={{ xxs: 12, xs: 6, s: 3 }} gap="s8">
      <Box alignItems="center" flexDirection="row" height="s24">
        <Text size="200" weight="normal" color="grey800">
          {i18n.t('contract_versions.contract_information.contract_type')}
        </Text>
      </Box>
      {contractTypeName && (
        <Text size="300" weight="medium" color="grey1000">
          {contractTypeName}
        </Text>
      )}
      {!contractTypeName && (
        <Text size="300" weight="medium" color="grey600">
          {i18n.t('contract_versions.contract_information.not_informed')}
        </Text>
      )}
    </Box>
  )
}

export default ContractType
